export const ADD_FOOTPRINT = 'ADD_FOOTPRINT'
export const REMOVE_FOOTPRINT = 'REMOVE_FOOTPRINT'

export const ADD_SAVING = 'ADD_SAVING'
export const REMOVE_SAVING = 'REMOVE_SAVING'

export const UPDATE_SETTINGS = 'UPDATE_SETTINGS'